import { AboutLockInfo } from '~/components/AboutLockInfo'

import { useLockTotalOverview } from './useLockTotalOverview'

import styles from './TotalStakingOverview.pcss'

export function TotalStakingOverview() {
	const { totalSupply, locked, estimateYieldPerWeek, apr } =
		useLockTotalOverview()

	return (
		<div className={styles.container}>
			<div className={styles.title}>TOTAL STAKING OVERVIEW</div>
			<div className={styles.content}>
				<AboutLockInfo
					digits={2}
					hint="This is an estimated value. It is calculated based on the total number of SIS tokens locked at the time of calculation and the amount of rewards allocated weekly. "
					label="Est. APR:"
					value={apr}
					percent
				/>
				<AboutLockInfo
					hint="This is an estimated value. It is based on the previous week rewards pool"
					label="Est. weekly rewards pool"
					postfix="SIS"
					value={estimateYieldPerWeek}
					invertPlaceholder
				/>
				<AboutLockInfo
					label="veSIS Supply:"
					postfix="veSIS"
					value={totalSupply}
				/>
				<AboutLockInfo
					label="Locked:"
					postfix="SIS"
					value={locked}
					invertPlaceholder
				/>
			</div>
		</div>
	)
}
